export default __webpack_public_path__ + "7408b709aaef8e5b6cacce3d82eb61fd.woff";